import React, { Component } from "react";
import { Box } from "gestalt";
import classNames from "classnames/bind";
import styles from "../../src/App.css";
let cx = classNames.bind(styles);
class CategoryFilter extends Component {
  handleChange = category => {
    this.props.onChange(category);
  };
  render() {
    const { products, activeCategory } = this.props;
    const categoryArray = ["all"];
    products.map(product => {
      product.category.map(category => {
        if (categoryArray.indexOf(category) < 0) {
          categoryArray.push(category);
        }
        return null;
      });
    });
    return (
      <div className="scroll">
        <Box marginTop={3} marginBottom={3}>
          {categoryArray.map((category, index) => (
            <a
              className={cx({
                categoryFilter: true,
                font: true,
                active: category === activeCategory
              })}
              key={index}
              onClick={() => this.handleChange(category)}
            >
              {category}
            </a>
          ))}
        </Box>
      </div>
    );
  }
}

export default CategoryFilter;



// WEBPACK FOOTER //
// ./src/Components/category-filter.js